import type { Localized } from '@/content/schema';

/**
 * "What's new?" for families, one entry per release, newest first. The first
 * entry must match the version in package.json (a test checks it), so every
 * release says what changed. See docs/MAINTENANCE.md.
 */
export interface ChangelogEntry {
  version: string;
  date: string;
  changes: Array<{ emoji: string; text: Localized }>;
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '0.3.0',
    date: '2026-10-20',
    changes: [
      {
        emoji: '📌',
        text: {
          ar: 'قواعد مُبرَزة في الدروس، مثل «قانون العقد»، مع أمثلة ورسوم، ودفتر قواعد لكلّ مادّة.',
          fr: 'Des règles mises en valeur dans les leçons, avec des exemples et des dessins, et un carnet de règles par matière.',
          en: 'Highlighted rules in lessons, with examples and pictures, and a rule book for each subject.',
        },
      },
      {
        emoji: '🧮',
        text: {
          ar: 'العمليّة العموديّة: علامة العمليّة على اليسار، ونتدرّب على العمليّتين الأفقيّة والعموديّة معًا.',
          fr: 'Les opérations en colonnes ont le signe à gauche ; on s’entraîne en ligne et en colonnes.',
          en: 'Column sums show the sign on the left; children practise sums on one line and in columns.',
        },
      },
      {
        emoji: '🎤',
        text: {
          ar: 'الإجابة بالصوت (تجريبيّة): يفعّلها الوليّ لكلّ طفل من فضاء الوليّ.',
          fr: 'Répondre à voix haute (test) : un parent l’active pour chaque enfant dans l’espace parent.',
          en: 'Voice answers (test): a parent switches them on for each child in the parent area.',
        },
      },
      {
        emoji: '🗳️',
        text: {
          ar: 'صوّتوا على ما نضيفه في النسخة القادمة، وشاركونا أفكاركم.',
          fr: 'Votez pour la prochaine version et partagez vos idées.',
          en: 'Vote for what comes in the next version and share your ideas.',
        },
      },
      {
        emoji: '🎉',
        text: {
          ar: 'صفحة «ما الجديد؟» تعرض ما تغيّر في كلّ نسخة.',
          fr: 'La page « Quoi de neuf ? » montre ce qui change à chaque version.',
          en: 'The “What’s new?” page shows what changes in each version.',
        },
      },
    ],
  },
  {
    version: '0.2.0',
    date: '2026-10-19',
    changes: [
      {
        emoji: '🚙',
        text: {
          ar: 'اسم جديد: ObiGo، مع شعار ورفيق جديدين.',
          fr: 'Nouveau nom : ObiGo, avec un nouveau logo et une nouvelle mascotte.',
          en: 'New name: ObiGo, with a new logo and mascot.',
        },
      },
      {
        emoji: '⬅️',
        text: {
          ar: 'العمليّات الحسابيّة بالعربيّة تُكتب وتُقرأ من اليمين إلى اليسار.',
          fr: 'En arabe, les calculs s’écrivent et se lisent de droite à gauche.',
          en: 'In Arabic, calculations are written and read from right to left.',
        },
      },
      {
        emoji: '🖼️',
        text: {
          ar: 'رسوم توضيحيّة في الدروس والتلميحات والشروح.',
          fr: 'Des illustrations dans les leçons, les indices et les explications.',
          en: 'Illustrations in lessons, hints and explanations.',
        },
      },
      {
        emoji: '💬',
        text: {
          ar: 'يمكن للأطفال تقييم الألعاب والإبلاغ عن سؤال، ويمكن للأولياء إرسال ملاحظاتهم.',
          fr: 'Les enfants peuvent noter les jeux et signaler une question ; les parents peuvent envoyer leurs remarques.',
          en: 'Children can rate games and report a question; parents can send feedback.',
        },
      },
    ],
  },
  {
    version: '0.1.0',
    date: '2026-10-19',
    changes: [
      {
        emoji: '🌱',
        text: {
          ar: 'النسخة الأولى: خمس موادّ وعشر ألعاب وفضاء للوليّ.',
          fr: 'Première version : cinq matières, dix jeux et un espace parent.',
          en: 'First version: five subjects, ten games and a parent area.',
        },
      },
    ],
  },
];
